import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalSelector = (state: ReduxState) => number
const getTotalAwsCertificates: TotalSelector = state => state.awsCertificates.pagination.total

export const totalSelector: TotalSelector = createSelector(getTotalAwsCertificates, total => total)
